import { DONE, statusCategoryForId } from '@atlassian/jira-common-constants/src/status-categories';
import {
	ISSUE_KEY_TYPE,
	ISSUE_TYPE_GQL_FIELD,
	PARENT_GQL_FIELD,
	PRIORITY_GQL_FIELD,
	STATUS_GQL_FIELD,
	SUMMARY_TYPE,
	TEXT_GQL_FIELD,
	USER_PICKER_GQL_FIELD,
} from '@atlassian/jira-platform-field-config';
import type { BoardIssueOld } from '../../common/types';
import type {
	JIS2_JiraBusinessBoardSubtaskItems_subtaskIssues_jwmViewItems_JiraWorkManagementViewItemConnection_edges_node as JIS2SubtaskIssueDetails,
	JIS2_JiraBusinessBoardSubtaskItems_subtaskIssues_jwmViewItems_JiraWorkManagementViewItemConnection_edges_node_fieldsByIdOrAlias_JiraSingleLineTextField as JiraSingleLineTextField,
	JIS2_JiraBusinessBoardSubtaskItems_subtaskIssues_jwmViewItems_JiraWorkManagementViewItemConnection_edges_node_fieldsByIdOrAlias_JiraSingleSelectUserPickerField as JiraSingleSelectUserPickerField,
} from './__generated_apollo__/JIS2_JiraBusinessBoardSubtaskItems';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const transformSubtaskOld = (
	subtask: JIS2SubtaskIssueDetails | null,
): BoardIssueOld | undefined => {
	if (subtask == null) {
		return undefined;
	}
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const toReturn: BoardIssueOld = {
		id: subtask.issueId,
		url: '',
		columnId: 0,
		dueDate: null,
		numCompleteChildren: 0,
		numTotalChildren: 0,
	} as BoardIssueOld;

	const processTextFields = (field: JiraSingleLineTextField) => {
		switch (field.fieldId) {
			case ISSUE_KEY_TYPE:
				toReturn.key = field.text || '';
				break;
			case SUMMARY_TYPE:
				toReturn.summary = field.text || '';
				break;
			default:
				break;
		}
	};

	const processAssignee = (field: JiraSingleSelectUserPickerField) => {
		if (field.user == null) {
			toReturn.assignee = null;
		}
		toReturn.assignee = {
			id: field.user?.accountId || '',
			displayName: field.user?.name || '',
			avatarUrl: field.user?.picture || '',
		};
	};

	subtask.fieldsByIdOrAlias?.forEach((field) => {
		switch (field?.__typename) {
			case TEXT_GQL_FIELD:
				processTextFields(field);
				break;
			case ISSUE_TYPE_GQL_FIELD:
				toReturn.issueTypeId = field.issueType?.issueTypeId || '';
				toReturn.typeName = field.issueType?.name || '';
				toReturn.typeUrl = field.issueType?.avatar?.medium || '';
				break;
			case STATUS_GQL_FIELD:
				{
					toReturn.statusId = Number(field.status?.statusId || 0);
					toReturn.statusName = field.status?.name || '';
					const statusCategoryId = Number(field.status?.statusCategory?.statusCategoryId || 0);
					toReturn.statusCategory = statusCategoryId;
					toReturn.isDone = statusCategoryForId(statusCategoryId) === DONE;
				}
				break;
			case PRIORITY_GQL_FIELD:
				toReturn.priority = {
					name: field.priority?.name || '',
					iconUrl: field.priority?.iconUrl || '',
				};
				break;
			case USER_PICKER_GQL_FIELD:
				processAssignee(field);
				break;
			case PARENT_GQL_FIELD:
				toReturn.parentId =
					field.parentIssue?.issueId == null ? null : Number(field.parentIssue?.issueId);
				break;
			default:
				break;
		}
	});
	return toReturn;
};
